// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1zKv-","content":"LayoutSettings_content__1Bl8F"};